export default __webpack_public_path__ + "static/media/carroVistoriado.bde33c9d.png";